import { render, staticRenderFns } from "./ExportConfigPanel.vue?vue&type=template&id=48145c0a&scoped=true"
import script from "./ExportConfigPanel.vue?vue&type=script&lang=js"
export * from "./ExportConfigPanel.vue?vue&type=script&lang=js"
import style0 from "./ExportConfigPanel.vue?vue&type=style&index=0&id=48145c0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48145c0a",
  null
  
)

export default component.exports